import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "page-search-m" }
const _hoisted_2 = { class: "layout-search-form" }
const _hoisted_3 = { class: "layout-search-result" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = {
  key: 1,
  class: "no-data"
}

import { ref } from "vue";
import { NPagination } from "naive-ui";
import { useSearch } from "@/composables/useSearch";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let router = useRouter();
let pageSize = 10;

let { keyword, list, TotalCount, page, fetchContent, navigate } =
  useSearch(pageSize);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "来输入点内容看看吧~",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(keyword) ? (keyword).value = $event : keyword = $event)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_unref(fetchContent) && _unref(fetchContent)(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _unref(keyword)]
      ]),
      _createElementVNode("div", {
        class: "btn-search",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(fetchContent) && _unref(fetchContent)(...args)))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(list).data && _unref(list).data.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list).data, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                tag: "div",
                onClick: ($event: any) => (_unref(navigate)(item)),
                class: "result-item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.Title), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(item.Summary), 1)
              ], 8, _hoisted_4))
            }), 128)),
            _createVNode(_unref(NPagination), {
              "page-sizes": [_unref(pageSize)],
              "item-count": _unref(TotalCount),
              page: _unref(page),
              "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
              "show-quick-jumper": "",
              style: {"display":"flex","justify-content":"center","padding":"60px"},
              simple: ""
            }, null, 8, ["page-sizes", "item-count", "page"])
          ], 64))
        : (_openBlock(), _createElementBlock("h1", _hoisted_7, "暂无内容"))
    ])
  ]))
}
}

})